import { apiRequest } from '../services/ApiService.js';

import {
  EMPLOYEE_FIELD_CHANGED,
  EMPLOYEE_LOADING,
  EMPLOYEE_PRINT_CLAIM_SUCCESS,
  EMPLOYEE_GET_BANKING_SUCCESS,
  EMPLOYEE_SET_BANKING_SUCCESS,
  SET_NOTIFICATIONS,
  GENERAL_REQUEST_LOADED,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_UPDATE_SUCCESS,
  EMPLOYEE_AGREEMENT,
  EMPLOYEE_AGREEMENT_SUCCESS,
  EMPLOYEE_AGREEMENT_FAIL,
  EMPLOYEE_DEPENDANT_SUCCESS,
  EMPLOYEE_DEPENDANT_FAIL,
  EMPLOYEE_BANKING_IMAGE_ADD,
  EMPLOYEE_BANKING_IMAGE_ADD_SUCCESS,
  EMPLOYEE_BANKING_IMAGE_ADD_FAILED,
  EMPLOYEE_BANKING_IMAGE_RESET,
  AUTH_EMPLOYEE,
  AUTH_EMPLOYEE_FAIL,
  AUTH_EMPLOYEE_SUCCESS,
  GENERAL_REQUEST_LOADING,
  CLAIM_UPDATE_PATIENTS_SUCCESS,

  SNACKBAR_SET,
} from './types';

import history from '../utility/common/History.js';
import { Validate, HSAMaxImageSize, inArray } from '../utility/common/GlobalHSA.js';

// ******************************************************************** //
// ************ General *********************************************** //
// ******************************************************************** //
export const updateEmployeeField = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: EMPLOYEE_FIELD_CHANGED,
      fieldName: fieldName,
      fieldValue: fieldValue
    })
  };
};

// ******************************************************************** //
// ************ Get Employee Data ************************************* //
// ******************************************************************** //
export const authEmployeeRequest = (userId, employeeId, path, token, callback) => {
  return (dispatch) => {

    dispatch({ type: AUTH_EMPLOYEE });

    authEmployee(dispatch, userId, employeeId, token, callback);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
const authEmployee = (dispatch, userId, employeeId, token, callback) => {

  const responseDispatches = { fail: AUTH_EMPLOYEE_FAIL, success: AUTH_EMPLOYEE_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: callback };
  const showSnackBar = { fail: true, success: false };

  const data = {
    userId: userId,
    eeId: employeeId,
    token: token
  }

  apiRequest(dispatch, 
    history, 
    token, 
    '/employee', 
    data, 
    responseDispatches,
    responseRedirects,
    showSnackBar,
    responseFunctions,
    true,
    false);

}

// ******************************************************************** //
// ************ Get Employee Print Claim  ***************************** //
// ******************************************************************** //
export const authEmployeePrintClaimRequest = (token, requestedId) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_EMPLOYEE_FAIL, success: EMPLOYEE_PRINT_CLAIM_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const endpoint = '/employee/get-print-form';
    const data = {requestedId: requestedId};

    apiRequest(dispatch, 
      history, 
      token, 
      endpoint, 
      data, 
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  };
};

// ******************************************************************** //
// ************ Get Employee Banking Details ************************** //
// ******************************************************************** //
export const authGetEmployeeBankingDetails = (token, eeId) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_EMPLOYEE_FAIL, success: EMPLOYEE_GET_BANKING_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = {eeId: eeId};
    const endpoint = '/employee/banking-details';

    apiRequest(dispatch, 
      history, 
      token, 
      endpoint, 
      data, 
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
// ************ Set Employee Banking Details ************************** //
// ******************************************************************** //
export const authSetEmployeeBankingDetails = (token, eeId, transitNumber, institutionNumber, accountNumber, imageObj, eft_agreement) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_EMPLOYEE_FAIL, success: EMPLOYEE_SET_BANKING_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = {fail: employeeBankingImageReset, success:employeeBankingImageReset};
    const showSnackBar = { fail: true, success: true };
    const data = {eeId: eeId, 
      transitNumber: transitNumber, 
      institutionNumber: institutionNumber, 
      accountNumber: accountNumber, 
      eft_agreement: (eft_agreement)? 'Y' : 'N', 
      image: imageObj};
    const endpoint = '/employee/banking-details/save';

    apiRequest(dispatch, 
      history, 
      token, 
      endpoint, 
      data, 
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
// ************ Set Cheque Image ************************************** //
// ******************************************************************** //
export const employeeBankingImageAdd = (imageObj) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYEE_BANKING_IMAGE_ADD, imageObj });
    processEmployeeBankingImageAdd(dispatch, imageObj);
  }
}

// ******************************************************************** //
const processEmployeeBankingImageAdd = (dispatch, imageObj) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: EMPLOYEE_BANKING_IMAGE_ADD_FAILED, success: EMPLOYEE_BANKING_IMAGE_ADD_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  if(typeof imageObj !== "object") { error = true; errors.GENERAL = 'Invalid banking document'; }

  //check if valid file types
  if(!inArray(['image/jpeg','image/png','application/pdf'],imageObj.type)) { error = true; errors.GENERAL = 'Invalid document type, please choose a JPEG, PNG, or PDF'; }

  //check if size is bigger than 4mb
  if(imageObj.size > HSAMaxImageSize) { error = true; errors.GENERAL = 'Maximum document size cannot exceed 5MB.'; }

  if(error === false) {
    employeeBankImageUploadSuccess(
      dispatch,
      imageObj,
      'Banking document attached',
      responseDispatches.success,
      responseRedirects.success,
      showSnackBar.success
    );
  } else {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Could not add banking document';
    employeeBankImageUploadFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }

}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employeeBankingImageReset = () => {
  return (dispatch) => {
    dispatch({ type: EMPLOYEE_BANKING_IMAGE_RESET });
  }
}


// ******************************************************************** //
/*  */
// ******************************************************************** //
export const hsaAgreement = (agreement, token) => {
  return (dispatch) => {

    dispatch({ type: EMPLOYEE_AGREEMENT });

    hsaAgreementValidation(dispatch, agreement, token);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const hsaAgreementValidation = (dispatch, agreement, token) => {
  //validate the data
  let errors = {};

  if(!agreement || agreement !== true) errors.general = 'Please accept the agreement to continue';

  if(Object.keys(errors).length > 0){
    hsaAgreementFail(
      dispatch,
      true,
      errors
    );
  } else {
    const responseDispatches = { fail: EMPLOYEE_AGREEMENT_FAIL, success: EMPLOYEE_AGREEMENT_SUCCESS };
    const responseRedirects = { fail: null, success: '/' };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const data = {agreement: agreement};
    const endpoint = '/employee/agreement';

    apiRequest(dispatch, 
      history, 
      token, 
      endpoint, 
      data, 
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

   }

}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const hsaAgreementFail = (dispatch, error, errors) => {
  dispatch({
    type: EMPLOYEE_AGREEMENT_FAIL,
    error,
    errors
  });
};

// ******************************************************************** //
// ************ Employee Update *************************************** //
// ******************************************************************** //
export const employeeNotifications = (erId, userId, token) => {
  return (dispatch) => {

    dispatch({ type: EMPLOYEE_LOADING });

    const responseDispatches = { fail: EMPLOYEE_AGREEMENT_FAIL, success: SET_NOTIFICATIONS };
    const responseRedirects = { fail: null, success: '/' };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const data = {erId: erId, userId: userId };
    const endpoint = '/employee/get-notifications';

    apiRequest(dispatch, 
      history, 
      token, 
      endpoint, 
      data, 
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employeeUpdate = (employee, userId, minBirthDate, token) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    employeeValidation(dispatch, employee, userId, minBirthDate, token);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employeeValidation = (dispatch, employee, userId, minBirthDate, token) => {

  //validate the data
  let errors = {};

  if(!employee) errors.GENERAL = 'Invalid employee';

  if(!userId) errors.GENERAL = 'Invalid user request';

  if(!employee.FIRST_NAME || employee.FIRST_NAME === '' || employee.FIRST_NAME ===null) errors.FIRST_NAME = 'Please fill out your first name.';

  if(!employee.LAST_NAME || employee.LAST_NAME === '' || employee.LAST_NAME === null) errors.LAST_NAME = 'Please fill out your last name.';

  if(!employee.STREET1 || employee.STREET1 === '' || employee.STREET1 === null) errors.STREET1 = 'Please fill out your address.';

  if(!employee.CITY || employee.CITY === '' || employee.CITY === null) errors.CITY = 'Please fill out your city.';

  if(employee.POSTCODE && Validate(employee.POSTCODE, 'isPostal') !== true) errors.POSTCODE = 'Invalid postal code format.';

  if(!employee.POSTCODE || employee.POSTCODE === '' || employee.POSTCODE === null) errors.POSTCODE = 'Please fill out your postal code.';

  if(!employee.PROVINCE || employee.PROVINCE === '' || employee.PROVINCE === null) errors.PROVINCE = 'Please select a province.';

  if(employee.TELEPHONE && Validate(employee.TELEPHONE, 'isTelephone') !== true) errors.TELEPHONE = 'Invalid telephone format.';

  if(!employee.TELEPHONE || employee.TELEPHONE === '' || employee.TELEPHONE === null) errors.TELEPHONE = 'Please fill out your telephone.';

  if(employee.EMAIL && Validate(employee.EMAIL, 'isEmail') !== true) errors.EMAIL = 'Invalid email format.';

  if(!employee.EMAIL || employee.EMAIL === '' || employee.EMAIL === null) errors.EMAIL = 'Please fill out your email.';

  if(!employee.DATE_OF_BIRTH || employee.DATE_OF_BIRTH === '' || employee.DATE_OF_BIRTH === null) errors.DATE_OF_BIRTH = 'Please fill out your date of birth.';

  if(employee.DATE_OF_BIRTH < minBirthDate) errors.DATE_OF_BIRTH = 'Birthdate is younger than allowed for this plan.';

  if(employee.CELLPHONE && Validate(employee.CELLPHONE, 'isTelephone') !== true) errors.CELLPHONE = 'Invalid telephone format.';

  if(employee.FAX && Validate(employee.FAX, 'isTelephone') !== true) errors.FAX = 'Invalid telephone format.';

  if(Object.keys(errors).length > 0){
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Please correct the missing information above';
    dispatch({
      type: EMPLOYEE_UPDATE_FAIL,
      error: true,
      errors
    });
    dispatch({ type: GENERAL_REQUEST_LOADED });
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  } else {
    employeeUpdateCall(dispatch, employee, userId, token);
  }

}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employeeUpdateCall = (dispatch, employee, userId, token) => {

  const responseDispatches = { fail: EMPLOYEE_UPDATE_FAIL, success: EMPLOYEE_UPDATE_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };
  const data = {
    employee: employee,
    userId: userId,
    token: token
  };
  const endpoint = '/employee/update';

  apiRequest(dispatch, 
    history, 
    token, 
    endpoint, 
    data, 
    responseDispatches,
    responseRedirects,
    showSnackBar,
    responseFunctions,
    true,
    false);

}

// ******************************************************************** //
// ************ Dependent Functions *********************************** //
// ******************************************************************** //
const dependantRequest = (dispatch, endpoint, dataObj, token) => {

  const responseDispatches = { fail: EMPLOYEE_DEPENDANT_FAIL, success: [EMPLOYEE_DEPENDANT_SUCCESS, CLAIM_UPDATE_PATIENTS_SUCCESS] };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };
  const data = {
    data: dataObj,
    token: token
  };

  apiRequest(dispatch, 
    history, 
    token, 
    endpoint, 
    data, 
    responseDispatches,
    responseRedirects,
    showSnackBar,
    responseFunctions,
    true,
    false);
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employeeExtendDependentRequest = (token, eeId, depId, depExtDate) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    const data = { eeId: eeId, depId: depId, depExtDate: depExtDate };
    dependantRequest(dispatch, '/employee/dependant/extend', data, token);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employeeEditDependentRequest = (token, eeId, depId, depBirthDate, depIsStudent) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    const data = { eeId: eeId, depId: depId, depBirthDate: depBirthDate, depIsStudent: depIsStudent };
    dependantRequest(dispatch, '/employee/dependant/edit', data, token);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employeeAddDependentRequest = (token, eeId, depFirstName, depLastName, depRelation, depBirthDate, depEffectiveDate, depIsStudent) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    const data = { eeId: eeId,
      depBirthDate: depBirthDate,
      depFirstName: depFirstName,
      depLastName: depLastName,
      depRelation: depRelation,
      depEffectiveDate: depEffectiveDate,
      depIsStudent: depIsStudent };
    dependantRequest(dispatch, '/employee/dependant/add', data, token);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employeeDeleteDependentRequest = (token, eeId, depId) => {
  return (dispatch) => {
    dispatch({ type: GENERAL_REQUEST_LOADING });

    const data = { eeId: eeId, depId: depId };
    dependantRequest(dispatch, '/employee/dependant/delete', data, token);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employeeBankImageUploadSuccess = (
  dispatch,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    data,
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employeeBankImageUploadFail = (
  dispatch,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    error,
    errors
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(errors.FORCE_LOGOUT){
    // dispatch({
    //   type: LOGOUT,
    // });
    history.push('/logout');
  } else {
    if(responseRedirect) history.push(responseRedirect);
  }
};
